<p class="{{class}}" [hidden]="!text">{{text}}
    <span class="text-error font-weight-bold"
        [hidden]="status == 6 && aboutToExpirytext == ''">{{aboutToExpirytext}}</span>
    <span class="text-error font-weight-bold" [hidden]="status == 9 && suspensionText == ''">{{suspensionText}}</span>
    <span class="text-link font-weight-bold" ngbPopover="popContent" triggers="mouseenter:mouseleave"
        container="body">{{secondDocumentPart3}}
    </span>
    <ng-template #popContent>
        <div class="popoverCustomWidth">
            <p class="text-primary font-weight-bold text-logo-blue">({{secondDocumentPart1}}
            </p>
            <p class="text-primary font-weight-bold">{{ 'grade_status' | translate}}&nbsp;:
                <span [style.color]="colorStatusBeforeExpiry" class="font-weight-bold">{{secondDocumentPart2}}</span>)
            </p>
        </div>
    </ng-template>
</p>